import React, { useEffect, useRef, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../azureaad/authconfig";
import { AzureAuthProvider } from "../azureaad/azureauthprovider";

// ✅ Ensure SINGLE instance
const msalInstance = new PublicClientApplication(msalConfig);

export const AzureBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [ready, setReady] = useState(false);
    const initializedRef = useRef(false);

    useEffect(() => {
        // ✅ Prevent double-run in React 18 StrictMode
        if (initializedRef.current) return;
        initializedRef.current = true;

        const bootstrap = async () => {
            try {
                await msalInstance.initialize();

                const response = await msalInstance.handleRedirectPromise();

                if (response?.account) {
                    msalInstance.setActiveAccount(response.account);
                } else {
                    // ✅ Handle refresh / cached session
                    const accounts = msalInstance.getAllAccounts();
                    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
                        msalInstance.setActiveAccount(accounts[0]);
                    }
                }
            } catch (error) {
                console.error("Azure auth bootstrap failed:", error);
            } finally {
                // ✅ Never block app forever
                setReady(true);
            }
        };

        bootstrap();
    }, []);

    if (!ready) {
        return <div>Signing In…</div>; // or spinner/splash
    }

    return (
        <MsalProvider instance={msalInstance}>
            <AzureAuthProvider>
                {children}
            </AzureAuthProvider>
        </MsalProvider>
    );
};